import { render, staticRenderFns } from "./PaymentInfoGroupedRow.vue?vue&type=template&id=510458f4&scoped=true"
import script from "./PaymentInfoGroupedRow.vue?vue&type=script&lang=js"
export * from "./PaymentInfoGroupedRow.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoGroupedRow.vue?vue&type=style&index=0&id=510458f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510458f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510458f4')) {
      api.createRecord('510458f4', component.options)
    } else {
      api.reload('510458f4', component.options)
    }
    module.hot.accept("./PaymentInfoGroupedRow.vue?vue&type=template&id=510458f4&scoped=true", function () {
      api.rerender('510458f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentInfoGroupedRow.vue"
export default component.exports